<template>
  <div class="table-container elevation-1">
    <v-data-table :headers="headers" :items="userlist" :sort-by="'CreatedAt'" :sort-desc="true" :search="search" :footer-props="{'items-per-page-options': [25, 50, 100, -1]}" :items-per-page="25">
      <template v-slot:top>
        <v-toolbar text color="white">
          <v-toolbar-title>User Admin</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select v-model="filterMembershipStatus" v-on:change="updateUserList" :items="membershipTypeListAll" label="Filter by Church Membership Status" class="mb-n6"></v-select>
          <v-spacer></v-spacer>
          <v-dialog v-model="showEditUser">
            <v-card>
              <v-card-title>
                <span class="headline">Editing {{ editedItem.preferredname }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h2 v-if="showErrorMessage">Error saving user information</h2>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select v-model="editedItem.membershipstatus" :items="membershipTypeList" label="Current Church Membership Status"></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch v-model="editedItem.verified" :label="
                          `Is verified: ${editedItem.verified.toString()}`
                        "></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch v-model="editedItem.isactivated" :label="
                          `Is Activated: ${editedItem.isactivated.toString()}`
                        "></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-switch v-model="editedItem.isadmin" :label="
                          `Has Administrative Privileges: ${editedItem.isadmin.toString()}`
                        "></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea v-model="editedItem.notes" label="notes" rows="1" auto-grow></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="blue darken-1" v-on:click="deleteUser">Delete User</v-btn>
                    </v-flex>
                    <v-flex xs12 v-if="deleteUserFailed">
                      <p class="red--text">Failed to Delete User</p>
                    </v-flex>
                    <v-flex xs12>
                      <v-select v-model="emailTypeSelect" :items="emailmessagelist" label="Select email to send"></v-select>
                    </v-flex>
                    <v-flex xs12 v-if="emailSuccess">
                      <p class="green--text">Email sent successfully</p>
                    </v-flex>
                    <v-flex xs12 v-if="emailFailed">
                      <p class="red--text">Email failed to send</p>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="blue darken-1" v-on:click="sendEmail">Send Email</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <v-select v-model="editedItem.roles" :items="rolesList" item-text="name" item-value="ID" chips label="Roles" multiple></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="blue darken-1" v-on:click="saveUserRoles">Update Roles</v-btn>
                    </v-flex>
                    <v-flex xs12 v-if="updateUserRoleSuccess">
                      <p class="green--text">Role Updated successfully</p>
                    </v-flex>
                    <v-flex xs12 v-if="updateUserRoleFailed">
                      <p class="red--text">Role Update Failed</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text v-on:click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text v-on:click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.isactivated="{ item }">
        <v-icon v-if="item.isactivated" color="green" v-text="'check_circle'"></v-icon>
        <v-icon v-else color="red" v-text="'cancel'"></v-icon>
      </template>
      <template v-slot:item.verified="{ item }">
        <v-icon v-if="item.verified" color="green" v-text="'check_circle'"></v-icon>
        <v-icon v-else color="red" v-text="'cancel'"></v-icon>
      </template>
      <template v-slot:item.isadmin="{ item }">
        <v-icon v-if="item.isadmin" color="green">check_circle</v-icon>
        <v-icon v-else color="red">cancel</v-icon>
      </template>
      <template v-slot:item.name="{ item }">
        <v-icon small class="mr-2" v-on:click="editItem(item)">edit</v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>
      </template>
    </v-data-table>
    <v-snackbar v-model="deleteUserSuccess" :timeout="snackbarTimeout">
      Successfully Deleted User
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      showEditUser: false,
      showErrorMessage: false,
      EditUserName: "",
      headers: [
        { text: "Title", value: "title" },
        { text: "Full Name", value: "preferredname" },
        { text: "Email Address", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Verified", value: "verified" },
        { text: "Activated", value: "isactivated" },
        { text: "Membership Status", value: "membershipstatus" },
        { text: "Administrator", value: "isadmin" },
        { text: "Actions", value: "name", sortable: false },
        { text: "Joined Date", value: "CreatedAt" },
      ],
      sourceuserlist: [],
      userlist: [],
      search: "",
      editedIndex: -1,
      editedItem: {
        index: -1,
        preferredname: "",
        email: "",
        verified: false,
        isactivated: false,
        membershipstatus: "Non-member",
        isadmin: false,
        CreatedAt: "",
        notes: "",
        roles: [],
      },
      emailTypeSelect: "",
      emailmessagelist: [
        "Send Activation Email to Member (Email 4)",
        "Send Activation Email to Non-member (Campers) (Email 5)",
        "Send Activation Email to Associate Member (Email 6)",
        "Send Response Email to Approved Member (Email 7)",
        "Send Response Email to Non-approved User (Email 8)",
      ],
      updateUserRoleSuccess: false,
      updateUserRoleFailed: false,
      emailSuccess: false,
      emailFailed: false,
      deleteUserSuccess: false,
      deleteUserFailed: false,
      snackbarTimeout: 1000,
      membershipTypeList: [
        "Infant baptised, not reaffirmed",
        "Infant baptised and reaffirmed",
        "Adult baptised in Life BPC",
        "Transferred into Life BPC",
        "Non-member",
        "Associate Member",
        "Seminar-Only",
        "Adult-Sunday-School",
        "Camp-Only"
      ],
      membershipTypeListAll: [
        "All",
        "Infant baptised, not reaffirmed",
        "Infant baptised and reaffirmed",
        "Adult baptised in Life BPC",
        "Transferred into Life BPC",
        "Non-member",
        "Associate Member",
        "Seminar-Only",
        "Adult-Sunday-School",
        "Camp-Only"
      ],
      filterMembershipStatus: "All",
      rolesList: [],
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    close() {
      this.showEditUser = false;
      this.showErrorMessage = false;
      this.updateUserRoleSuccess = false;
      this.updateUserRoleFailed = false;
      this.emailSuccess = false;
      this.emailFailed = false;
    },
    initialize() {
      this.userlist = [];
      this.sourceuserlist = [];
      axios
        .get("/api/admin/userlist")
        .then((response) => {
          this.sourceuserlist = response.data;
          this.userlist = response.data;
        })
        .catch(() => {});
      // fetch user roles for edited user
      axios({
        url: "/api/admin/roles",
        method: "GET",
      })
        .then((response) => {
          // if failed to save - make a snackbar show up
          Object.assign(this.rolesList, response.data);
          this.close();
        })
        .catch(() => {
          this.showErrorMessage = true;
        });
    },
    saveUserRoles() {
      let param = {
        user_id: this.editedItem.ID,
        role_ids: this.editedItem.roles,
      };
      axios({
        url: "/api/admin/updateuserrole",
        data: param,
        method: "PUT",
      })
        .then(() => {
          this.updateUserRoleSuccess = true;
          this.updateUserRoleFailed = false;
        })
        .catch(() => {
          this.updateUserRoleSuccess = false;
          this.updateUserRoleFailed = true;
        });
    },
    sendEmail() {
      let param = {
        email: this.editedItem.email,
        message: this.emailTypeSelect,
      };
      axios({
        url: "/api/admin/emailuser",
        data: param,
        method: "PUT",
      })
        .then(() => {
          this.emailSuccess = true;
          this.emailFailed = false;
        })
        .catch(() => {
          this.emailSuccess = false;
          this.emailFailed = true;
        });
    },
    deleteUser() {
      axios({
        url: "/api/admin/deleteuser/" + this.editedItem.ID,
        method: "DELETE",
      })
        .then(() => {
          this.deleteUserSuccess = true;
          this.deleteUserFailed = false;
          this.showEditUser = false;
        })
        .catch(() => {
          this.deleteUserSuccess = false;
          this.deleteUserFailed = true;
        });
    },
    save() {
      // try to save the item with server first
      let param = {
        email: this.editedItem.email,
        verified: this.editedItem.verified,
        isactivated: this.editedItem.isactivated,
        membershipstatus: this.editedItem.membershipstatus,
        ismember: this.editedItem.ismember,
        isadmin: this.editedItem.isadmin,
        notes: this.editedItem.notes,
      };
      axios({
        url: "/api/admin/updateuser",
        data: param,
        method: "PUT",
      })
        .then(() => {
          // if failed to save - make a snackbar show up
          Object.assign(this.userlist[this.editedIndex], this.editedItem);
          this.close();
        })
        .catch(() => {
          this.showErrorMessage = true;
        });
    },
    editItem(item) {
      this.editedIndex = this.userlist.indexOf(item);
      this.editedItem = item;
      this.emailSuccess = false;
      this.emailFailed = false;
      let userRoleRoute = "/api/admin/getuserrole/" + item.ID;
      axios({
        url: userRoleRoute,
        method: "GET",
      })
        .then((response) => {
          // if failed to save - make a snackbar show up
          if (response.data != null && response.data.length == 0) {
            this.editedItem.roles = [];
          } else {
            this.editedItem.roles = response.data.map((x) => x.ID);
          }
          // only call this after all the data is setup
          this.showEditUser = true;
        })
        .catch(() => {
          this.showErrorMessage = true;
        });
    },
    updateUserList() {
      console.log("updateUserList called with " + this.filterMembershipStatus);
      if (this.filterMembershipStatus == "All") {
        this.userlist = this.sourceuserlist;
      } else {
        this.userlist = this.sourceuserlist.filter(
          (user) => user.membershipstatus == this.filterMembershipStatus
        );
      }
    },
  },
};
</script>

<style></style>
